import * as React from 'react';
import './toggler.scss';
import { cn } from '../../utils';

interface Props {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  styles?: any;
  children?: any;
}

export const Toggler = ({
  checked,
  onChange,
  disabled,
  label,
  styles,
  children
}: Props) => {
  return (
    <div
      className={cn({ 'toggle-switch-disabled': disabled }, 'toggle-switch')}
      style={styles ? styles : null}
    >
      {label && <label>{label}</label>}
      {!!children && children}
      <label className="switch">
        <input
          type="checkbox"
          disabled={disabled}
          onChange={e => onChange(e.target.checked)}
          checked={!!checked}
        />
        <span className="togger round"></span>
      </label>
    </div>
  );
};
